import React from 'react';
import FlowContainer from '../components/FlowContainer';
import RequestFlow from '../components/RequestFlow';

const RequestMatch = () => {
  return (
    <FlowContainer>
      <RequestFlow variant="match" />
    </FlowContainer>
  );
};

export default RequestMatch;
